export const costs = [
  'Noches en vela buscando cómo traducir conceptos de criminalística complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la criminalística no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta sobre análisis forense o interpretación de evidencias y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos de criminalística y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar fundamentos de criminalística, ciencias forenses, seguridad o tecnología sin los recursos adecuados.',
];
